import React, { Component } from 'react';
import {connect} from "react-redux";
import {SlideDown} from 'react-slidedown'

class Price extends Component {
  state = {
    closed: true
  };

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      closed: !this.state.closed
    })
  }

  render() {
    const bodyPrice = new Intl.NumberFormat('ja-JP').format(this.props.products.currentItem.price);
    //const totalPrice = new Intl.NumberFormat('ja-JP').format(this.props.products.price.total * 1.08);
    const discount = new Intl.NumberFormat('ja-JP').format(this.props.products.price.discount * -1);
    const amount = new Intl.NumberFormat('ja-JP').format(this.props.products.totalAmount);

    let unitPrice = this.props.products.currentItem.price;

    return (
      <div className="t-container-price">
        <div className="t-container-price-title" onClick={this.toggle}>
          {this.props.products.currentItem.title} / {this.props.products.currentColor.name}
        </div>
        <SlideDown closed={this.state.closed}>
          <div className="t-container-price-collapsible">
            <table className="table">
              <tbody>
                <tr>
                  <td>本体価格</td>
                  <td className="text-right">{bodyPrice}円</td>
                </tr>
                {this.props.objects.present.surfaces.map((surface, i) => {
                  const hasObjects = (Object.keys(this.props.objects.present.objects[surface.surface.id]).length) > 0;

                  if (hasObjects) {
                    const surfacePrice = new Intl.NumberFormat('ja-JP').format(surface.surface.price);
                    unitPrice += surface.surface.price;

                    return (
                      <tr key={i}>
                        <td>{surface.surface.name}</td>
                        <td　className="text-right">{surfacePrice}円</td>
                      </tr>
                    );
                  }

                  return null;
                })}
                <tr>
                  <td>スポンサー割引</td>
                  <td className="text-right">{discount}円</td>
                </tr>
                <tr>
                  <td colSpan="2" className="text-right">
                    <small>1セットあたり</small> {new Intl.NumberFormat('ja-JP').format(unitPrice)}円
                  </td>
                </tr>
              </tbody>
            </table>
            <hr/>
            <table className="table">
              <tbody>
                <tr>
                  <td>数量</td>
                  <td className="text-right">{amount}セット</td>
                </tr>
                <tr>
                  <td>送料</td>
                  <td className="text-right">無料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </SlideDown>

        <div className="t-container-price-footer">
          <table className="table">
            <tbody>
              <tr>
                <td>合計金額(税込)</td>
                <td className="text-right">{new Intl.NumberFormat('ja-JP').format(Math.floor(unitPrice * 1.1) * this.props.products.totalAmount)}円</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default connect(f => f, {})(Price);


// WEBPACK FOOTER //
// ./src/containers/Price.js